module.exports = __webpack_public_path__ + "img/header_img.b18fc0ed.webp";